import { Checkbox } from "antd"
import { useState } from "react";

function useTreeShowLowActivity(selectedTarget) {
    const [showLowActivity, setShowLowActivity] = useState(false);

    return {
        showLowActivity,
        lowActComponent: !((selectedTarget?.code || selectedTarget?.key)?.includes("mokb")) ? null : <div className="d-flex-col">
            <Checkbox
                checked={showLowActivity}
                onChange={(e) => {
                    setShowLowActivity(e.target.checked);
                }}
            >
                Show segments with Low Activity
            </Checkbox>
        </div>
    }
}

export default useTreeShowLowActivity